export default __webpack_public_path__ + "static/media/LSP2.e9e915ae.png";